import type { MealHistory, MealLogEntry } from './types'

// One meal's entries, newest first. Only cooked entries count as cooks; a note alone doesn't.
export function mealHistory(entries: readonly MealLogEntry[], mealId: string | null): MealHistory {
  const mine = entries.filter((e) => e.mealId === mealId).sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
  const cooks = mine.filter((e) => e.cooked)
  return { entries: mine, cookCount: cooks.length, lastCookedAt: cooks[0]?.createdAt }
}
